import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  Router,
  NavigationExtras,
  ActivatedRoute
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Project, School, SchoolCategory, Partner, Country, Region, User, Role } from '../../model/project.model';
// import { MyErrorHandler } from '../../errorhandler/errorhandler';
import * as schoolforms from '../school.management.forms';
import { SchoolManagementService } from '../../../../../schoolmanagement/src/app/service/schoolmanagement.service';

declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-school-form',
  templateUrl: './CtlSchoolForm.html',
  styleUrls: ['./CtlSchoolForm.css'],
  providers: [SchoolManagementService]
})

export class CtlSchoolForm implements OnInit {

  @Input() myFormGroup: FormGroup;
  @Input() project_id: string;
  @Input() projectName: string;
  @Input() school_id: string;
  @Input() mySchoolCategoryList: SchoolCategory[];
  @Input() myCountryList: Country[];
  @Input() myRegionList: Region[];
  @Input() myCountry: Country;
  @Input() modalType: string;
  @Input() viewType: string;
  @Input() data: any;
  @Input() edited: boolean;
  action: string;
  message: string;
  tokenGenerated = false;
  newregion: string;
 // edited=true;
  @Output() schoolFormChange: EventEmitter<boolean> = new EventEmitter();

  @Output() enableArchive: EventEmitter<boolean> = new EventEmitter();
  @Output() schoolUpdate: EventEmitter<boolean> = new EventEmitter();
  @Output() evEditEnable: EventEmitter<boolean> = new EventEmitter();

  // complete form school
  schoolForm: FormGroup;
  // schoolForm = new FormGroup(schoolforms.formSchool);

  logo_url: string;
  loginInfoObj = null;
  isLoggedin = null;
  schoolCategoryListData: any[];
  regionSelectConfig:any;
  categorySelectConfig:any;

  

  constructor(
    private el: ElementRef,
    public translate: TranslateService,
    private schoolService: SchoolManagementService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.translate.get('Select a region').subscribe((translated: string) => {
      this.regionSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: true,
        height: '180px',
        customComparator: (function(a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.categorySelectConfig = {
        placeholder: this.translate.instant('Select a School Category'),
        displayKey: 'name',
        search: false,
        height: '150px'
      };
    });
    if (this.myFormGroup) {
      this.schoolForm = this.myFormGroup;
      if (this.myCountry) {
        this.schoolForm.get('country').patchValue(this.myCountry);
      }
    } else {
      this.schoolForm = new FormGroup(schoolforms.formSchool);
      this.schoolForm.reset();
      if(this.myCountry) {
        this.schoolForm.get('country').patchValue(this.myCountry);
      }
    }
    this.schoolForm.valueChanges.subscribe(data => {
      //console.log('school form change ' + JSON.stringify(data));
      this.schoolFormChange.emit(true);
    });

    if (this.school_id) {
      this.tokenGenerated = true;
    }
    this.loginInfoObj = JSON.parse(this.returnLoginInfoObj())
    this.isLoggedin = window.localStorage.getItem('loginInfoObj');
  //  alert("data="+JSON.stringify(this.data));
  }
  ngAfterViewInit() {
    if (this.myFormGroup) {
      this.schoolForm = this.myFormGroup;
      if (this.myCountry) {
        this.schoolForm.get('country').patchValue(this.myCountry);
      }
    } else {
      this.schoolForm = new FormGroup(schoolforms.formSchool);
      this.schoolForm.reset();
      if (this.myCountry) {
        this.schoolForm.get('country').patchValue(this.myCountry);
      }
    }

    this.schoolForm.valueChanges.subscribe(data => {
     // console.log('school form change ' + JSON.stringify(data));
      this.schoolFormChange.emit(true);
    });
  }

  ngOnDestroy() {
    //
  }
/*   enableDisableSchool(status) {
    if (status.invalid) {
      this.disableProject(this.school_id);
    } else {
      this.enableProject(this.school_id);
    }
  } */
  confirmEnableDisable(checkstatus) {
    //alert("confirm enable");
   
    //console.log("checkbox " + checkstatus+" data.active="+this.data.active);
//     if (this.data.active === checkstatus )
//       this.edited=false;
//     else
//       this.edited=true;
// console.log("this.edited="+this.edited);
    this.enableArchive.emit(checkstatus);
    // setTimeout(() => {
    //   this.edited=true;
    // }, 2);
  }
  schoolUpdated() {
    //alert("confirm enable");
    this.schoolUpdate.emit(true);
  }
  /* disableProject(school_id) {
    this.schoolService.disable(school_id).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandler = new ErrorHandler(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  enableProject(school_id) {
    this.schoolService.enable(school_id).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandler = new ErrorHandler(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  } */
  edit() {
    //this.curView='edit';
    this.evEditEnable.emit(true);
    //alert('edit33');
  }
  removePhoto() {
    //
    this.schoolForm.get('logo').patchValue({'url': null});
    console.log('remove photo');
  }
  returnLoginInfoObj() {
    return window.localStorage.getItem('loginInfoObj')
  }
  myListFormatter(data: any): string {
    console.log('list data ' + JSON.stringify(data));
    return `${data.name.charAt(0).toUpperCase() + data.name.slice(1)}`; // make first letter in uppercase
  }

  myValueFormatter(data: any): string {
    console.log('value data ' + JSON.stringify(data));
    return `${data.name.charAt(0).toUpperCase() + data.name.slice(1)}`; // make first letter in uppercase
  }

  onAddSchoolFormSubmit() {
    console.log('School Form Data row ' + JSON.stringify(this.schoolForm.value));
    // redirect on success

    let data: any;
    data = this.schoolForm.value;

    Object.keys(data).forEach(element => {
      if (!data[element] || data[element] === undefined) {
        delete data[element];
      }
    });

    console.log('School Form Data target :' + JSON.stringify(data));

    this.schoolService.create(JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  addSchool() {
    console.log('School Form Data ' + JSON.stringify(this.schoolForm.value));
    // redirect on success
    //alert("this.mycountry="+this.myCountry);
    let data = this.schoolForm.value;
    if (this.project_id) {
      data.project_id = this.project_id;
    }
    data.country = this.myCountry
    if (data.country && data.country._id) {
      data.country = data.country._id;
    }

    if (data.category && data.category._id) {
      data.category = data.category._id;
    }

    if (data.region && data.region._id) {
      data.region = data.region._id;
    }

    if (data._id) {
      delete data._id;
    }

    if (data.admins) {
      delete data.admins;
    }

    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);

    console.log("school form data updated :" + JSON.stringify(data));

    this.schoolService.create(JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        if (response.school_id) {
          this.school_id = response.school_id;
          this.schoolForm.get('_id').patchValue(response.school_id);
          this.action = 'success';
          this.message = 'School added successfully!';
          this.schoolFormChange.emit(true);
        }
      },
      (err) => {
        this.action = 'failure';
        this.message = 'Failed to add school, try again or contact administrator!';
        this.schoolFormChange.emit(true);
        console.log('ERROR: ' + err);
      },
      () => {
        console.log('COMPLETED');
      }

    );
  }

  updateSchool() {
   // console.log('School Form Data ' + JSON.stringify(this.schoolForm.value));
    // redirect on success
    const data = this.schoolForm.value;
    if (this.project_id) {
      data.project_id = this.project_id;
    }
    if (this.school_id) {
      data.school_id = this.school_id;
    }

    data.country=this.myCountry;
    if (data.country && data.country._id) {
      data.country = data.country._id;
    }

    if (data.category && data.category._id) {
      data.category = data.category._id;
    }

    if (data.region && data.region._id) {
      data.region = data.region._id;
    }

    if (data._id) {
      delete data._id;
    }

    Object.keys(data).forEach(element => {
      if (!data[element] || data[element] === undefined) {
        delete data[element];
      }
    });

    //console.log("school form data updated :" + JSON.stringify(data));

    this.schoolService.update(this.school_id, JSON.stringify(data)).subscribe(
      (response) => {
        //console.log(' School Full Response: ' + JSON.stringify(response));
        //window.localStorage.setItem('editSchoolUpdated', this.school_id);
       //this.router.navigate(['/schoolmanagement/overview/'+this.school_id+"/"+this.project_id]);
        this.schoolUpdated();
      },
      (err) => {
        this.action = 'failure';
        this.message = 'Failed to update school, try again or contact administrator!';
        this.schoolFormChange.emit(true);
        console.log('ERROR: ' + err);
      },
      () => {
        //console.log('COMPLETED');
      }

    );
  }

  onSchoolFormSubmit() {

   // console.log('school form data :' + JSON.stringify(this.schoolForm.value));
    if (this.school_id) {
      this.updateSchool();
    } else {
      this.addSchool();
    }
  }

  resetForm() {
    this.schoolForm.reset();
  }

  generateCode(name, country, city) {
    // school name, region, country
    let code = '';
    let random = 5;
    const initialsArray = name.match(/\b(\w)/g);
    let initials = initialsArray.join('');
    if (initials.length > 3) {
      initials = initials.substring(0, 3);
      random = 2;
    } else {
      random = random - initials.length;
    }
    let text = '';
    const possible = 'abcdefghijklmnopqrstuvwxy';

    for (let i = 0; i < random; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    // add condition for 1-3 word school name
    code = country.code.toLowerCase() + city.substring(0, 2).toLowerCase() + text + initials.toLowerCase();

    this.schoolForm.get('code').patchValue(code);
    return;
    // this.schoolForm.get('token').patchValue('1k3kk5k1k15nn362ln15lkn151l1n515n155');
  }

  generateToken() {
    let text = '';
    const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 30; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    this.schoolForm.get('token').patchValue(text);
    return;
  }

  addRegion(newregion: string) {
    let region = newregion;
    if (region === '' || region === undefined) {
      return;
    }
      region = region.charAt(0).toUpperCase() + region.slice(1);
      this.schoolService.addRegion(JSON.stringify({ 'name': region, 'project_id': this.project_id })).subscribe(
        (response) => {
          // console.log(' Full Response: ' + JSON.stringify(response));
          this.listRegion();
          this.schoolForm.get('region').patchValue({ '_id': response.region_id, 'name': region, 'project_id': this.project_id });
          //this.nameChanged({});
          return;
        },
        (err) => {
          console.log('ERROR: ' + err);
          this.listRegion();
        },
        () => {
          console.log('COMPLETED');
        }
      );
  }

  listRegion() {
    this.schoolService.listRegion(this.project_id).subscribe(
      (response) => {
        console.log('Full Response: ' + JSON.stringify(response));
        //this.myRegionList = response;
        this.myRegionList = response;
        this.myRegionList = [...this.myRegionList, {'_id': 'new', 'name': ' - New region', 'description': 'add new'}];
        //this.myRegionList.push({'_id': 'new', 'name': ' - New Region', 'description': 'add new'});
      },
      (err) => {
        console.log('Error: ' + err);
        this.myRegionList = [];
        this.myRegionList.push({'_id': 'new', 'name': ' - New region', 'description': 'add new'});
      },
      () => {
        console.log('Completed');
      }
    );
  }

  nameChanged(event) {
    if (event && event.target && event.target.value) {
      //console.log('changed :' + event.target.value);
    }
    if (!this.tokenGenerated && !this.school_id && (
      this.schoolForm.get('name').value &&
      //this.schoolForm.get('country').value &&
      this.schoolForm.get('contact.city').value)
    ) {
      //
      this.generateCode(
        this.schoolForm.get('name').value,
        this.myCountry,
        this.schoolForm.get('contact.city').value
      );
      this.generateToken();
      this.tokenGenerated = true;
    }
  }
}
